var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.97521 12.0505V12.7879C9.97521 14.0096 8.98485 15 7.76309 15C6.54134 15 5.55098 14.0096 5.55098 12.7879V12.0505M9.97521 12.0505H5.55098M9.97521 12.0505H12.6227C12.9048 12.0505 13.0465 12.0505 13.1607 12.012C13.3789 11.9384 13.5496 11.7671 13.6232 11.5489C13.6619 11.4343 13.6619 11.2921 13.6619 11.0078C13.6619 10.8834 13.6617 10.8212 13.652 10.7619C13.6336 10.6498 13.5901 10.5435 13.5239 10.4513C13.4889 10.4026 13.4443 10.3581 13.3567 10.2703L13.0694 9.98314C12.9768 9.89045 12.9247 9.76473 12.9247 9.6337V6.8889C12.9247 4.03822 10.6138 1.72729 7.76309 1.72729C4.91242 1.7273 2.60149 4.03823 2.60149 6.8889V9.6337C2.60149 9.7648 2.54931 9.89045 2.45664 9.98314L2.16943 10.2703C2.08147 10.3583 2.03742 10.4025 2.00237 10.4513C1.93612 10.5436 1.89224 10.6498 1.87385 10.7619C1.86411 10.8212 1.86411 10.8834 1.86411 11.0079C1.86411 11.2921 1.86411 11.4342 1.90279 11.5489C1.97638 11.7671 2.14785 11.9384 2.36601 12.012C2.48023 12.0505 2.6214 12.0505 2.90348 12.0505H5.55098M12.201 1C13.218 1.76637 14.0192 2.78304 14.5266 3.95102M3.32556 1C2.30856 1.76637 1.50737 2.78304 1 3.95102",
    stroke: "#1B224C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.09de6c1560e921220d27936d5976c2f6.svg";
export { ForwardRef as ReactComponent };